import React from "react";
import { Users, Layers, Smartphone, Globe2, Bot, Cog, ShieldCheck, Sparkles } from "lucide-react";

const services = [
  { Icon: Users, t: "Queue Management SaaS", d: "Token systems, smart routing & live displays for clinics, banks and govt offices." },
  { Icon: Bot, t: "AI Chatbots & Agents", d: "Branded assistants trained on your data — voice, text, multilingual." },
  { Icon: Cog, t: "Business Automation", d: "Workflow engines, internal tooling and integrations with your existing stack." },
  { Icon: Layers, t: "Custom Software Dev", d: "Bespoke SaaS, dashboards, internal systems engineered to last." },
  { Icon: Smartphone, t: "Mobile Apps", d: "Premium iOS & Android experiences with offline-first architecture." },
  { Icon: Globe2, t: "Enterprise Websites", d: "Editorial, conversion-tuned sites with SEO and analytics baked-in." },
  { Icon: Sparkles, t: "AI Marketplace Access", d: "Unified access to ChatGPT, Claude, Gemini, Grok and more — one workspace." },
  { Icon: ShieldCheck, t: "Compliance & Security", d: "SOC-style controls, role-based access, encrypted data at rest & in transit." },
];

export default function Services() {
  return (
    <section id="services" className="section" data-testid="services-section">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div>
            <div className="eyebrow mb-4">Services</div>
            <h2 className="font-serif text-4xl md:text-5xl text-white tracking-tight max-w-3xl leading-[1.05]">
              End-to-end <span className="gold-text italic">capabilities</span> for ambitious teams.
            </h2>
          </div>
          <p className="max-w-md text-white/55 text-sm leading-relaxed">
            Eight focused practice areas — assembled into one luxurious operating layer for your business.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map(({ Icon, t, d }, i) => (
            <div key={t} className="glass-card p-6 h-full flex flex-col" data-testid={`service-card-${i}`}>
              <div className="h-10 w-10 rounded-xl flex items-center justify-center border border-gold-500/30 bg-gold-500/[0.06]">
                <Icon className="h-5 w-5 text-gold-300" strokeWidth={1.5} />
              </div>
              <div className="mt-5 font-serif text-xl text-white">{t}</div>
              <div className="mt-2 text-sm text-white/55 leading-relaxed">{d}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
